import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../components/Header";
import { Helmet } from "react-helmet-async";

function HoldingScreen() {
  const [companyName, setCompanyName] = useState("");

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setCompanyName(params.get("client") || "your Company");
  }, [location.search]);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/get-in-touch", label: "Get in touch" },
  ];

  return (
    <>
      <Header links={navLinks} />

      <Helmet>
        <title>{companyName} | DataPulse AI</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>


      <main>
        <section className="bg-white dark:bg-gray-900">
          <div className="max-w-screen-xl px-4 py-10 mx-auto lg:py-24 lg:px-6 text-center">
            <div className="max-w-screen-xl px-4 mx-auto mb-8 text-center lg:mb-12">
              <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                Exciting Times Ahead for <span className="text-title-purple">{companyName}</span> & <span className="text-title-purple">DataPulse AI</span>! 🚀
              </h2>

              <br />
              <span className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">
                Our team at DataPulse AI is working hard on your project! ✅
                <br /><br />
                You've taken the first step toward smarter automation, streamlined systems, and exponential business growth.
                <br /><br />
                We'll be in touch soon with an update! 🥳
                <br /><br />
                <a href="/" className="flex text-2xl justify-center pl-4 ml-1 font-semibold text-gray-900 dark:text-white">
                  <img src="https://www.mydatapulse.co.uk/icons/1.png" className="h-6 sm:h-9" alt="DataPulse Logo" />
                </a>
              </span>
            </div>
          </div>
        </section>
      </main>

    </>
  );
}

export default HoldingScreen;
